import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const HamburgerButton = ({ onClick, isOpen }) => {
  return (
    <button
      onClick={onClick}
      className="fixed top-4 right-4 z-50 p-2 bg-dark-card rounded-lg text-gray-400 hover:text-white lg:hidden transition-all duration-200"
    >
      {isOpen ? (
        <XMarkIcon className="w-6 h-6" />
      ) : (
        <Bars3Icon className="w-6 h-6" />
      )}
    </button>
  );
};

export default HamburgerButton; 